import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

const BarPercentage = ({
  className,
  percent,
}: {
  className?: string
  percent: number
}) => {
  if (!(percent >= 0 && percent <= 100)) {
    return null
  }
  return (
    <div className={clsx(s.mainBar, className)}>
      <div
        className={s.secondBar}
        style={{ width: `${Math.round(percent)}%` }}
      ></div>
    </div>
  )
}

export default BarPercentage
